import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback, useEffect, useRef } from "react";
import { CommentDisplay } from "~/components/Discussions/CommentDisplay";
import { DiscussionForm } from "~/components/Discussions/DiscussionForm";
import { DISCUSSION_COMMENT_BODY, EDIT_COMMENT_FORM } from "~/constants/testIDs";
export const DiscussionCommentContent = /*#__PURE__*/ memo((param)=>{
    let { comment, mentionsList, onSave, shouldShowMentionsButton, isEditing, cancelEditing, metadata } = param;
    const commentForm = useRef(null);
    const { isAboveMediumScreen } = useBreakpointsContext();
    useEffect(()=>{
        if (isEditing) {
            var _commentForm_current;
            (_commentForm_current = commentForm.current) === null || _commentForm_current === void 0 ? void 0 : _commentForm_current.focus();
        }
    }, [
        isEditing
    ]);
    const onCommentSubmit = useCallback((body)=>{
        onSave === null || onSave === void 0 ? void 0 : onSave(body);
        cancelEditing();
    }, [
        cancelEditing,
        onSave
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isEditing && onSave ? /*#__PURE__*/ _jsx("div", {
            className: "discussion-form-container",
            children: /*#__PURE__*/ _jsx(DiscussionForm, {
                "data-testid": EDIT_COMMENT_FORM,
                ref: commentForm,
                comment: comment.body,
                hasCancelButton: isEditing && !isAboveMediumScreen,
                mentionsList: mentionsList,
                onCancel: cancelEditing,
                onSubmit: onCommentSubmit,
                shouldShowMentionsButton: isAboveMediumScreen && shouldShowMentionsButton
            })
        }) : /*#__PURE__*/ _jsx("div", {
            className: "mr-4 flex w-fit",
            children: /*#__PURE__*/ _jsx(CommentDisplay, {
                className: "select-text",
                metadata: metadata,
                text: comment.body,
                "data-testid": DISCUSSION_COMMENT_BODY,
                mentionsList: mentionsList
            })
        })
    });
});
DiscussionCommentContent.displayName = "DiscussionCommentContent";
